<template>
    <div>
        <Title>基本信息</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.projectName }}</div>
            <div class="label">阶段</div>
            <div class="value1">
                <DataDictFinder dictType="phase" :dictValue="extra.phaseCode" />
            </div>
            <div class="label">校审编号</div>
            <div class="value2">{{ extra.auditNo }}</div>

            <div class="label">设计编号</div>
            <div class="value1">{{ extra.designNo }}</div>
            <div class="label">专业名称</div>
            <div class="value2">{{ extra.majorName }}</div>

            <div class="label">设计人</div>
            <div class="value1">{{ extra.designerName }}</div>
            <div class="label">校核人</div>
            <div class="value2">{{ extra.reviewerName }}</div>

            <div class="label">审核人</div>
            <div class="value1">{{ extra.auditorName }}</div>
            <div class="label">批准人</div>
            <div class="value2">{{ extra.approverName }}</div>

            <div class="label">成果编号</div>
            <div class="value1">{{ extra.results && extra.results[0] ? extra.results[0].resultNo : '-' }}</div>
            <div class="label">提交人</div>
            <div class="value2">{{ extra.results && extra.results[0] ? extra.results[0].submitUserName : '-' }}</div>
        </div>
        <Title>成果文件</Title>
        <div class="file-panel">
            <div class="file-content">
                <div class="file-result-list" :class="{ 'is-completed': isCompleted }">
                    <div class="file-item header">
                        <div class="col-name">成果名称</div>
                        <div class="col-attachment">附件</div>
                    </div>
                    <div class="file-item" v-for="(item, index) in extra.results" :key="index">
                        <div class="col-name">{{ item.resultName || '-' }}</div>
                        <div class="col-attachment">
                            <a-table
                                v-if="item.attachment && item.attachment.length"
                                :columns="attachmentColumns"
                                :data-source="item.attachment"
                                :pagination="false"
                                bordered
                                size="small"
                                row-key="id"
                            >
                                <template slot="nameLink" slot-scope="text, record">
                                    <a :href="deepDecodeURIComponent(record.completePath)" target="_blank" @click.prevent="handleFileClick($event, record.completePath, text)">{{ text }}</a>
                                </template>
                                <template slot="typeName" slot-scope="text">
                                    {{ text | typeFilter }}
                                </template>
                                <template slot="isSignName" slot-scope="text">
                                    {{ text ? '是' : '否' }}
                                </template>
                            </a-table>
                            <span v-else>-</span>
                        </div>
                    </div>
                </div>
            </div>
            <div id="audit-workspace" class="button-wrapper">
                <a-button v-if="showReviewWorkspace" type="primary" @click="openAnnotation(false)">进入成果审查工作区</a-button>
                <a-button v-if="showViewAnnotations" type="primary" @click="openAnnotation(true)">查看图审批注</a-button>
            </div>
        </div>
        <!-- 批注数量提示 -->
        <div class="comment-tip" v-if="showReviewWorkspace || showViewAnnotations">
            批注数量：{{filteredOpinionList.length}}
            批注状态：<span class="tip-text">{{ showViewAnnotations ? '请查看图审批注！' : '尚未进入过图审工作区！' }}</span>
        </div>
        <Title>校核、审核、审定意见</Title>
        <div id="audit-add-opinion" style="display:flex;justify-content:flex-end;margin-bottom:8px">
            <a-button v-if="showReviewWorkspace && hasOpinionEditing" type="primary" style="margin-right:8px" @click="handleSaveOpinions">保存</a-button>
            <a-button v-if="showReviewWorkspace" type="primary" @click="showAddOpinionModal">新增意见</a-button>
        </div>
        <div v-if="showReplySection && hasEditing" style="text-align:right;margin-bottom:8px">
            <a-button type="primary" @click="handleSave">保存</a-button>
        </div>
        <a-table
            :columns="opinionColumns"
            :data-source="filteredOpinionList"
            row-key="_key"
            :pagination="false"
            bordered
        >
            <template slot="stepName" slot-scope="text">
                {{ text | stepFilter }}
            </template>
            <template slot="titleContent" slot-scope="text, record">
                <template v-if="showReviewWorkspace && editingOpinionMap[record.id]">
                    <a-input v-model="editingOpinionContents[record.id].title" placeholder="标题" style="margin-bottom:4px" />
                    <a-textarea v-model="editingOpinionContents[record.id].content" placeholder="内容" :rows="2" />
                </template>
                <template v-else>
                    {{ text }}
                </template>
            </template>
            <template slot="reply" slot-scope="text, record">
                <template v-if="showReplySection && editingReplyMap[record.id]">
                    <a-input v-model="replyContents[record.id]" />
                </template>
                <template v-else>
                    {{ text }}
                </template>
            </template>
            <template slot="attachment" slot-scope="text">
                <a v-if="text" :href="text" target="_blank" @click.prevent="handleFileClick($event, text, $options.filters.fileNameDecode(text))">{{ text | fileNameDecode }}</a>
            </template>
            <template slot="action" slot-scope="text, record">
                <a-button v-if="showReplySection" size="small" @click="handleReply(record)">回复</a-button>
                <template v-if="showReviewWorkspace && record._sourceStep === currentTaskStep">
                    <a-space>
                        <a href="#" @click="handleEditOpinion(record)">编辑</a>
                        <a href="#" style="margin-left:8px" @click="handleDeleteOpinion(record)">删除</a>
                    </a-space>
                </template>
            </template>
        </a-table>
        <Padding />

        <a-modal
            title="新增意见"
            v-model="addOpinionVisible"
            width="600px"
            @ok="handleAddOpinionOk"
            @cancel="handleAddOpinionCancel"
            destroyOnClose
        >
            <a-form layout="horizontal" :colon="false" label-align="right" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="标题">
                    <a-input v-model="addOpinionForm.title" placeholder="请输入标题" />
                </a-form-item>
                <a-form-item>
                    <template slot="label"><span style="color: #f5222d;">*</span> 内容</template>
                    <a-textarea v-model="addOpinionForm.content" placeholder="请输入内容" :rows="3" />
                </a-form-item>
                <a-form-item>
                    <template slot="label"><span style="color: #f5222d;">*</span> 成果名称</template>
                    <a-select v-model="addOpinionForm.resultId" placeholder="请选择成果名称" @change="handleResultChange">
                        <a-select-option v-for="item in resultOptions" :key="item.id" :value="item.id">{{ item.resultName }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <template slot="label"><span style="color: #f5222d;">*</span> 成果附件</template>
                    <a-select v-model="addOpinionForm.attachmentId" placeholder="请选择成果附件" :disabled="!addOpinionForm.resultId" @change="handleAttachmentChange">
                        <a-select-option v-for="item in attachmentOptions" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="页面名称">
                    <a-select allow-clear v-model="addOpinionForm.pageId" placeholder="请选择页面名称" :disabled="!addOpinionForm.attachmentId">
                        <a-select-option v-for="item in pageOptions" :key="item.id" :value="item.id">{{ item.pageName }}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Title from "../Title";
import { getDesignResultAuditMarkupStatistics, fetchDesignResultAuditOpinions, replyDesignResultAuditMarkupComment, addDesignResultAuditMarkupComment } from "@/api/project-execute/result";
import { listPagesByFileId } from "@/api/project-design/countersign";
import { deleteAuditMarkupComment } from "@/api/audit";
export default {
    components: {
        Title,
    },
    data() {
        return {
            markupStats: {},
            reviewOpinionList: [],
            reviewOpinionsRaw: [],
            auditOpinionList: [],
            approveOpinionList: [],
            editingReplyMap: {},
            replyContents: {},
            editingOpinionMap: {},
            editingOpinionContents: {},
            fetchedAuditId: null,
            addOpinionVisible: false,
            addOpinionForm: {
                title: '',
                content: '',
                resultId: undefined,
                attachmentId: undefined,
                pageId: undefined,
            },
            attachmentOptions: [],
            pageOptions: [],
        };
    },
    filters: {
        stepFilter(val) {
            const map = {
                design_reviewer: '校核',
                design_auditor: '审核',
                design_approver: '审定',
                review_submit: '设计人提交',
            };
            return map[val] || val;
        },
        typeFilter(val) {
            const map = {
                calc: '计算书',
                spec: '说明书',
                blueprint: '图纸',
                text: '文本',
            };
            return map[val] || val;
        },
        fileNameDecode(val) {
            if (!val) return '';
            try {
                const match = val.match(/[^/]+\.pdf/i);
                return match ? decodeURIComponent(match[0]) : val;
            } catch {
                return val;
            }
        },
    },
    computed: {
        ...mapState("approval", ["detail"]),
        ...mapState("auth", ["user"]),
        isCompleted() {
            return this.$route.query.activeKey === 'COMPLETED';
        },
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        showReviewWorkspace() {
            return this.detail.taskDefinitionKey !== 'review_submit';
        },
        showViewAnnotations() {
            return this.markupStats.isFilesReviewed === true
                && this.detail.taskDefinitionKey === 'review_submit';
        },
        showReplySection() {
            return this.detail.taskDefinitionKey === 'review_submit'
        },
        hasEditing() {
            return Object.values(this.editingReplyMap).some(v => v);
        },
        hasOpinionEditing() {
            return Object.values(this.editingOpinionMap).some(v => v);
        },
        filteredOpinionList() {
            const allOpinions = [
                ...this.reviewOpinionList.map(item => ({ ...item, _sourceStep: 'design_reviewer' })),
                ...this.auditOpinionList.map(item => ({ ...item, _sourceStep: 'design_auditor' })),
                ...this.approveOpinionList.map(item => ({ ...item, _sourceStep: 'design_approver' })),
            ];
            return allOpinions.filter(item => {
                const hasTitle = item.title && item.title !== '-';
                const hasContent = item.content && item.content !== '-';
                return hasTitle || hasContent;
            }).map((item, index) => {
                const title = (item.title && item.title !== '-') ? item.title : '';
                const content = (item.content && item.content !== '-') ? item.content : '';
                return {
                    ...item,
                    titleContent: title && content ? `${title}/${content}` : title || content,
                    _key: `opinion_${index}`,
                };
            });
        },
        currentTaskStep() {
            return this.detail.taskDefinitionKey || '';
        },
        opinionColumns() {
            const columns = [
                { title: '环节', dataIndex: 'step', key: 'step', width: 50, scopedSlots: { customRender: 'stepName' } },
                { title: '提出人', dataIndex: 'createName', key: 'createName', width: 80 },
                { title: '图号', dataIndex: 'drawingNo', key: 'drawingNo', width: 100 },
                { title: '文件名', dataIndex: 'fileName', key: 'fileName', width: 120 },
                { title: '校核、审核、审定意见', dataIndex: 'titleContent', key: 'titleContent', minWidth: 200, scopedSlots: { customRender: 'titleContent' } },
                { title: '处理意见', dataIndex: 'reply', key: 'reply', minWidth: 200, scopedSlots: { customRender: 'reply' } },
                { title: '创建时间', dataIndex: 'createAt', key: 'createAt', width: 120 },
                { title: '附件', dataIndex: 'attachment', key: 'attachment', width: 150, scopedSlots: { customRender: 'attachment' } },
            ];
            if (this.showReplySection || this.showReviewWorkspace) {
                columns.push({ title: '操作', key: 'action', width: 130, scopedSlots: { customRender: 'action' } });
            }
            return columns;
        },
        attachmentColumns() {
            return [
                { title: '附件名', dataIndex: 'name', key: 'name', ellipsis: true, scopedSlots: { customRender: 'nameLink' } },
                { title: '附件类型', dataIndex: 'type', key: 'type', width: 100, scopedSlots: { customRender: 'typeName' } },
                { title: '是否签章', dataIndex: 'isSign', key: 'isSign', width: 100, scopedSlots: { customRender: 'isSignName' } },
            ];
        },
        resultOptions() {
            return (this.extra.results || []).map((item, index) => ({
                id: item.resultNo || String(index),
                resultName: item.resultName,
                attachment: item.attachment || [],
            }));
        },
        currentStep() {
            const name = this.detail.name;
            if (name === '审定') return 'design_approver';
            if (name === '校核') return 'design_reviewer';
            if (name === '审核') return 'design_auditor';
            return '';
        },
    },
    watch: {
        filteredOpinionList: {
            handler(val) {
                this.setFilteredOpinionList(val);
            },
            immediate: true,
        },
        'detail.extra': {
            handler(val) {
                if (val && val.auditId && val.auditId !== this.fetchedAuditId) {
                    this.fetchedAuditId = val.auditId;
                    this.fetchMarkupStats(val.auditId);
                    this.fetchAuditDetail(val.auditId);
                }
            },
            immediate: true,
        },
    },
    methods: {
        ...mapMutations("approval", ["setFilteredOpinionList"]),
        fetchMarkupStats(auditId) {
            getDesignResultAuditMarkupStatistics(auditId).then(res => {
                this.markupStats = res;
            });
        },
        fetchAuditDetail(id) {
            fetchDesignResultAuditOpinions(id, this.detail.taskDefinitionKey).then(res => {
                this.reviewOpinionsRaw = Array.isArray(res) ? res : (res.reviewOpinions || []);
                this.reviewOpinionList = this.reviewOpinionsRaw;
                this.auditOpinionList = Array.isArray(res) ? [] : (res.auditOpinions || []);
                this.approveOpinionList = Array.isArray(res) ? [] : (res.approveOpinions || []);
            });
        },
        handleReply(record) {
            this.$set(this.editingReplyMap, record.id, true);
            this.$set(this.replyContents, record.id, record.reply || '');
        },
        handleSave() {
            const ids = Object.keys(this.editingReplyMap).filter(id => this.editingReplyMap[id]);
            if (ids.length === 0) return;
            const replies = ids.map(id => ({
                id,
                replyContent: this.replyContents[id] || ''
            }));
            replyDesignResultAuditMarkupComment({ replies }).then(() => {
                this.editingReplyMap = {};
                this.replyContents = {};
                this.fetchAuditDetail(this.extra.auditId);
            });
        },
        handleEditOpinion(record) {
            this.$set(this.editingOpinionMap, record.id, true);
            this.$set(this.editingOpinionContents, record.id, {
                title: (record.title && record.title !== '-') ? record.title : '',
                content: (record.content && record.content !== '-') ? record.content : '',
            });
        },
        handleSaveOpinions() {
            const editingIds = Object.keys(this.editingOpinionMap).filter(id => this.editingOpinionMap[id]);
            if (editingIds.length === 0) return;

            const editedOpinions = this.filteredOpinionList.filter(item => editingIds.includes(String(item.id)));
            if (editedOpinions.length === 0) {
                this.$message.error('未找到可保存的编辑数据');
                return;
            }

            const now = new Date().toISOString();
            const fileCommentMap = {};
            const fileComments = [];

            editedOpinions.forEach(opinion => {
                const fId = opinion.fileId || '';
                const commentStep = opinion.step || '';
                const mapKey = `${fId}_${commentStep}`;
                if (!fileCommentMap[mapKey]) {
                    fileCommentMap[mapKey] = {
                        fileId: fId,
                        step: commentStep,
                        comments: [],
                    };
                    fileComments.push(fileCommentMap[mapKey]);
                }

                const edited = this.editingOpinionContents[opinion.id] || {};
                const pageId = opinion.pageId || '';

                let pageGroup = fileCommentMap[mapKey].comments.find(c => c.pageId === pageId);
                if (!pageGroup) {
                    pageGroup = { pageId, comments: [] };
                    fileCommentMap[mapKey].comments.push(pageGroup);
                }

                pageGroup.comments.push({
                    id: opinion.id || '',
                    content: (edited.content !== undefined ? edited.content : opinion.content) || '-',
                    title: (edited.title !== undefined ? edited.title : opinion.title) || '-',
                    position: opinion.position || JSON.stringify({ type: "comment", x: 50, y: 20, popupOffsetX: "30px", popupOffsetY: "-10px" }),
                    createAt: opinion.createAt || now,
                    createBy: opinion.createBy || this.user.uuid || '',
                    createName: opinion.createName || this.user.userName || '',
                    angle: opinion.angle != null ? opinion.angle : 0,
                });
            });

            addDesignResultAuditMarkupComment({ fileComments }).then(() => {
                // this.$message.success('保存成功');
                this.editingOpinionMap = {};
                this.editingOpinionContents = {};
                this.fetchAuditDetail(this.extra.auditId);
            }).catch(() => {
                this.$message.error('保存失败');
            });
        },
        handleDeleteOpinion(record) {
            if (!record.id) {
                this.$message.error('该意见无法删除');
                return;
            }
            this.$confirm({
                title: '确认删除',
                content: '确定要删除该意见吗？',
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    return deleteAuditMarkupComment(record.id).then(() => {
                        // this.$message.success('删除成功');
                        this.fetchAuditDetail(this.extra.auditId);
                    }).catch(() => {
                        this.$message.error('删除失败');
                    });
                }
            });
        },
        openAnnotation(viewMode) {
            const url = this.$router.resolve({
                name: "annotation",
                query: {
                    taskId: this.$route.query.taskId,
                    instanceId: this.$route.query.instanceId,
                    auditId: this.extra.auditId || "",
                    projectName: this.extra.projectName || "",
                    loginName: this.user.name || '',
                    userName: this.user.userName || '',
                    userId:this.user.uuid || '',
                    viewMode: viewMode ? 'view' : '',
                    taskDefinitionKey: this.detail.taskDefinitionKey || '',
                },
            }).href;
            window.open(url, "_blank");
        },
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        deepDecodeURIComponent(str) {
            // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
            // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
            // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
            let decoded = str;
            while (decoded.includes('%25')) {
                const prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
                if (decoded === prev) break;
            }
            return decoded;
        },
        handleFileClick(event, url, filename) {
            const decodedUrl = this.deepDecodeURIComponent(url);
            console.log("decodedUrl::",decodedUrl)
            if (this.isPdfFile(filename)) {
                event.preventDefault();
                this.previewPdf(decodedUrl, filename);
            } else {
                event.preventDefault();
                const link = document.createElement('a');
                link.href = decodedUrl;
                link.download = filename || 'download';
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        showAddOpinionModal() {
            this.addOpinionForm = { title: '', content: '', resultId: undefined, attachmentId: undefined, pageId: undefined };
            this.attachmentOptions = [];
            this.pageOptions = [];
            this.addOpinionVisible = true;
            if (this.resultOptions.length === 1) {
                this.$nextTick(() => {
                    this.addOpinionForm.resultId = this.resultOptions[0].id;
                    this.handleResultChange(this.resultOptions[0].id);
                });
            }
        },
        handleResultChange(resultId) {
            this.addOpinionForm.attachmentId = undefined;
            this.addOpinionForm.pageId = undefined;
            this.attachmentOptions = [];
            this.pageOptions = [];
            const selected = this.resultOptions.find(item => item.id === resultId);
            if (selected) {
                this.attachmentOptions = selected.attachment || [];
                if (this.attachmentOptions.length === 1) {
                    this.addOpinionForm.attachmentId = this.attachmentOptions[0].id;
                    this.loadPagesByAttachmentId(this.attachmentOptions[0].id);
                }
            }
        },
        handleAttachmentChange(attachmentId) {
            this.addOpinionForm.pageId = undefined;
            this.pageOptions = [];
            if (attachmentId) {
                this.loadPagesByAttachmentId(attachmentId);
            }
        },
        async loadPagesByAttachmentId(attachmentId) {
            this.pageOptions = [];
            try {
                const pages = await listPagesByFileId(attachmentId);
                this.pageOptions = Array.isArray(pages) ? pages : [];
                if (this.pageOptions.length === 1) {
                    this.addOpinionForm.pageId = this.pageOptions[0].id;
                }
            } catch (e) {
                this.pageOptions = [];
                console.error(e);
            }
        },
        handleAddOpinionOk() {
            if (!this.addOpinionForm.content) {
                this.$message.error('请输入内容');
                return;
            }
            if (!this.addOpinionForm.resultId) {
                this.$message.error('请选择成果名称');
                return;
            }
            if (!this.addOpinionForm.attachmentId) {
                this.$message.error('请选择成果附件');
                return;
            }

            const selectedPage = this.pageOptions.find(item => item.id === this.addOpinionForm.pageId);
            const pageId = selectedPage ? selectedPage.id : (this.addOpinionForm.pageId || '');
            const fileId = this.addOpinionForm.attachmentId || '';
            const step = this.currentStep;

            const fileComments = [];
            const fileCommentMap = {};

            if (this.reviewOpinionsRaw && this.reviewOpinionsRaw.length) {
                this.reviewOpinionsRaw.forEach(opinion => {
                    const fId = opinion.fileId || '';
                    const commentStep = opinion.step || '';
                    const mapKey = `${fId}_${commentStep}`;
                    if (!fileCommentMap[mapKey]) {
                        fileCommentMap[mapKey] = {
                            fileId: fId,
                            step: commentStep,
                            comments: [],
                        };
                        fileComments.push(fileCommentMap[mapKey]);
                    }
                    fileCommentMap[mapKey].comments.push({
                        pageId: '',
                        comments: [
                            {
                                id: opinion.id || '',
                                content: opinion.content || opinion.comment || '',
                                title: opinion.title || '',
                                position: opinion.position || JSON.stringify({ type: "comment", x: 50, y: 20, popupOffsetX: "30px", popupOffsetY: "-10px" }),
                                angle: opinion.angle != null ? opinion.angle : 0,
                            }
                        ],
                    });
                });
            }

            const newCommentKey = `${fileId}_${step}`;
            if (!fileCommentMap[newCommentKey]) {
                fileCommentMap[newCommentKey] = {
                    fileId: fileId,
                    step: step,
                    comments: [],
                };
                fileComments.push(fileCommentMap[newCommentKey]);
            }

            let maxPosX = 50;
            let maxPosY = 20;
            const allExistingComments = (fileCommentMap[newCommentKey].comments || []);
            allExistingComments.forEach(c => {
                if (c.comments && c.comments.length) {
                    c.comments.forEach(item => {
                        try {
                            const pos = typeof item.position === 'string' ? JSON.parse(item.position) : item.position;
                            if (pos && typeof pos.x === 'number' && typeof pos.y === 'number') {
                                if (pos.x >= maxPosX) maxPosX = pos.x + 10;
                                if (pos.y >= maxPosY) maxPosY = pos.y + 30;
                            }
                        } catch (e) {
                            // ignore parse errors
                        }
                    });
                }
            });

            const defaultPosition = JSON.stringify({
                type: "comment",
                x: maxPosX,
                y: maxPosY,
                popupOffsetX: "30px",
                popupOffsetY: "-10px"
            });

            fileCommentMap[newCommentKey].comments.push({
                pageId: pageId,
                comments: [
                    {
                        content: this.addOpinionForm.content,
                        title: this.addOpinionForm.title || '',
                        position: defaultPosition,
                        angle: 0,
                    }
                ],
            });

            const params = { fileComments };

            addDesignResultAuditMarkupComment(params).then(() => {
                this.addOpinionVisible = false;
                this.fetchAuditDetail(this.extra.auditId);
            }).catch(() => {
                this.$message.error('新增意见失败');
            });
        },
        handleAddOpinionCancel() {
            this.addOpinionVisible = false;
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }
}

/* 成果文件区域 */
.file-panel {
    border-top: 1px solid #e8e8e8;

    .file-content {
        margin-bottom: 8px;
    }

    .file-result-list {
        border: 1px solid #e8e8e8;
        background: #fff;

        &.is-completed {
            background: transparent;
        }

        .file-item {
            display: flex;
            border-bottom: 1px solid #e8e8e8;
            padding: 8px;

            &.header {
                background-color: #fafafa;
                font-weight: 500;
            }

            &:last-child {
                border-bottom: none;
            }

            .col-name {
                width: 180px;
                flex-shrink: 0;
                padding-right: 12px;
                line-height: 32px;
            }

            .col-attachment {
                flex: 1;
                min-width: 0;
            }
        }
    }

    .button-wrapper {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding: 8px 0;
    }
}

/* 批注数量提示 */
.comment-tip {
    margin-top: 10px;
    font-size: 14px;
    color: #333;

    .tip-text {
        background-color: #f8d7da;
        color: #721c24;
        padding: 2px 6px;
        border-radius: 3px;
    }
}
</style>